import styled from 'styled-components';

import { EmptyStatePlaceholder } from '@dreryk/react-components';

export const StyledEmptyStatePlaceholder = styled(EmptyStatePlaceholder)`
   width: 480px;
`;

StyledEmptyStatePlaceholder.displayName = 'StyledEmptyStatePlaceholder';
